import React, { Fragment } from 'react';
import { useTranslation } from '@pascal/pascal-core';
import Table from '../../assets/images/game/table-blue-info.png';
import Hit from '../../assets/images/game/GR_P8.png';
import Stand from '../../assets/images/game/GR_P9.png';
import Double from '../../assets/images/game/GR_P10.png';
import Split from '../../assets/images/game/GR_P11.png';
import Surrender from '../../assets/images/game/GR_P12.png';
import Insurance from '../../assets/images/game/GR_P36.png';
import { GAME_RULES_HELP_KEYS } from '../../enums/constants';

export function HelpPopup() {
  const t = useTranslation();
  const images = {
    2: Table,
    8: Hit,
    9: Stand,
    10: Double,
    11: Split,
    12: Surrender,
    36: Insurance,
  };

  return (
    <div className='game-rules'>
      {GAME_RULES_HELP_KEYS.map((item, index) => {
        return (
          <Fragment key={item}>
            {images[index] &&
              (index === 2 ? (
                <div className='game-rules-img'>
                  <img src={images[index]} alt='' />
                </div>
              ) : (
                <img src={images[index]} alt='' />
              ))}
            <p className='game-rules-text'>{t(`GAME_RULES_P${index + 1}`)}</p>
          </Fragment>
        );
      })}
      <p className='game-rule-table-row-item-txt'>{t('PAYOUT_TABLE')}</p>
      <div className='game-rule-table'>
        <div className='game-rule-table-row title'>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('BET')}</p>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('OUTCOME')}</p>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('ODD')}</p>
          </div>
        </div>
        <div className='game-rule-table-row'>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('MAIN')}</p>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('BLACKJACK')}</p>
            <p className='game-rule-table-row-item-txt'>{t('WIN')}</p>
            <p className='game-rule-table-row-item-txt'>{t('INSURANCE')}</p>
            <p className='game-rule-table-row-item-txt'>{t('SURRENDER')}</p>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>2.5</p>
            <p className='game-rule-table-row-item-txt'>2</p>
            <p className='game-rule-table-row-item-txt'>3</p>
            <p className='game-rule-table-row-item-txt'>0.5</p>
          </div>
        </div>
        <div className='game-rule-table-row'>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('SIDE_21_PLUS_3')}</p>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('FLUSH')}</p>
            <p className='game-rule-table-row-item-txt'>{t('STRAIGHT')}</p>
            <p className='game-rule-table-row-item-txt'>{t('THREE_OF_A_KIND')}</p>
            <p className='game-rule-table-row-item-txt'>{t('STRAIGHT_FLUSH')}</p>
            <p className='game-rule-table-row-item-txt'>{t('SUITED_TRIPS')}</p>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>6</p>
            <p className='game-rule-table-row-item-txt'>11</p>
            <p className='game-rule-table-row-item-txt'>31</p>
            <p className='game-rule-table-row-item-txt'>41</p>
            <p className='game-rule-table-row-item-txt'>101</p>
          </div>
        </div>
        <div className='game-rule-table-row'>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('PERFECT_PAIR')}</p>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('MIXED_PAIR')}</p>
            <p className='game-rule-table-row-item-txt'>{t('COLORED_PAIR')}</p>
            <p className='game-rule-table-row-item-txt'>{t('PERFECT_PAIR')}</p>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>6</p>
            <p className='game-rule-table-row-item-txt'>13</p>
            <p className='game-rule-table-row-item-txt'>26</p>
          </div>
        </div>
      </div>

      <p className='game-rule-table-row-item-txt'>{t('RTP')}</p>
      <div className='game-rule-table'>
        <div className='game-rule-table-row title'>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('BET')}</p>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('RTP')}</p>
          </div>
        </div>
        <div className='game-rule-table-row'>
          <div className='game-rule-table-row-item'>
            <div className='game-rule-table-row-item'>
              <p className='game-rule-table-row-item-txt'>{t('MAIN')}</p>
              <p className='game-rule-table-row-item-txt'>{t('SIDE_21_PLUS_3')}</p>
              <p className='game-rule-table-row-item-txt'>{t('PERFECT_PAIR')}</p>
            </div>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>99.47%</p>
            <p className='game-rule-table-row-item-txt'>96.30%</p>
            <p className='game-rule-table-row-item-txt'>95.90%</p>
          </div>
        </div>
      </div>
    </div>
  );
}
